import PrimaryPalette from '../../colors';

const Theme = {
  hover: {
    backgroundColor: PrimaryPalette.extraLightIris,
  },
  selected: {
    backgroundColor: PrimaryPalette.lightGrey,
  },
};

export default Theme;
